<script>
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'
import 'xterm/css/xterm.css'
import { mapState, mapActions, mapMutations } from 'vuex'
import axios from 'axios'

export default {
   name: 'ScrapRun',
   components: {},
   data() {
      return {
         request: null,
      }
   },
   computed: {
      ...mapState({
         myData: state => state.OssScrap.data,
         myCount: state => state.OssScrap.countAll,
         myCountDetail: state => state.OssScrap.countAllDetail,
         myCurrent: state => state.OssScrap.current,
         mySuccess: state => state.OssScrap.success,
         myFailed: state => state.OssScrap.failed,
         myState: state => state.OssScrap.runningState,
      }),
      isLoading() {
         return this.$store.state.isLoading
      },
      current: {
         get() {
            return this.myCurrent
         },
         set(value) {
            let newVal

            if (value) {
               newVal = value
            } else {
               newVal = 0
            }

            this.updateCurrent(parseInt(newVal, 10))
         },
      },
   },
   watch: {
      // isLoading(val) {
      //    if (val) {
      //       this.$swal({ text: 'Loading', allowOutsideClick: false })
      //       this.$swal.showLoading()
      //    } else {
      //       this.$swal.close()
      //    }
      // },
   },
   mounted() {
      // 1. Inisialisasi Terminal
      this.term = new Terminal({
         cursorBlink: true,
         fontSize: 14,
         fontFamily: 'Consolas, "Courier New", monospace',
         theme: {
            background: '#021a23',
            foreground: '#d4d4d4',
         },
      })
      // 2. Load Addon Fit
      this.fitAddon = new FitAddon()
      this.term.loadAddon(this.fitAddon)

      // 3. Pasang Terminal ke elemen DOM
      this.term.open(this.$refs.terminalContainer)

      // 4. Sesuaikan ukuran awal
      this.fitAddon.fit()

      // Tulis pesan sambutan
      // this.term.write('Xterm.js siap di Vue 2!\n\r')
      // this.term.write('$ ')

      // 5. Tambahkan Event Listener (jika Anda butuh input interaktif)
      this.term.onData(data => {
      // Anda dapat mengirim 'data' ini ke backend (misalnya melalui Socket.io atau API)
         this.term.write(data)
         if (data === '\r') {
            this.term.write('\n\r[Command received]\n\r$ ')
         }
      })

      window.addEventListener('resize', this.handleResize)

      this.onLoadList()
   },
   beforeDestroy() {
      // 6. Bersihkan (Dispose) Terminal
      // Ini sangat penting untuk mencegah memory leak di Vue 2
      window.removeEventListener('resize', this.handleResize)
      if (this.term) {
         this.term.dispose()
      }
   },
   methods: {
      ...mapActions({
         loginOss: 'OssScrap/runLogin',
         getData: 'OssScrap/getData',
         getDataError: 'OssScrap/getDataError',
         runScrap: 'OssScrap/runScrap',
         clearError: 'OssScrap/clearError',
      }),
      ...mapMutations({
         updateCurrent: 'OssScrap/SET_CURRENT',
         setState: 'OssScrap/SET_STATE',
         setCancelToken: 'OssScrap/SET_CANCEL_TOKEN',
         setReset: 'OssScrap/SET_RESET',
      }),
      onLoadError() {
         this.getDataError()
            .then(result => {
               console.log(result)
            })
            .catch(error => {
               console.log(error)
            })
      },
      run() {
         if (!this.myState) {
            return
         }
         const { nib } = this.myData[this.myCurrent]

         this.write(`Run ${this.myCurrent}`)
         this.write(`------ Body : { nib :${JSON.stringify(nib)} }`)

         console.log(nib)
         this.runScrap(nib).then(data => {
            if (data?.data) {
               this.write(`------ Response : \x1B[1;3;32m${JSON.stringify(data.data)}\x1B[0m `)
               this.clearError(nib)
            } else {
               // Jika request gagal, tampilkan pesan error + body response dari server (jika ada)
               const errMessage = [
                  data?.message,
                  data?.response?.data ? JSON.stringify(data.response.data) : null,
               ].filter(Boolean).join(' | ')

               this.write(`------ Response : \x1B[1;3;31m${errMessage || JSON.stringify(data)}\x1B[0m `)
            }

            if (this.myCurrent < this.myCount) {
               this.loadingRun = false
               this.run()
            } else {
               this.setState(false)
            }
         })
      },
      onStart() {
         this.write('Start Run')
         const axiosSource = axios.CancelToken.source()
         this.request = { cancel: axiosSource.cancel }
         this.setCancelToken(axiosSource.token)
         this.setState(true)
         this.run()
      },
      onStop() {
         this.write('\x1B[1;3;31mStop\x1B[0m')
         this.setState(false)
         this.request.cancel()
      },
      onLoadList() {
         this.setReset()
         this.write('Start : Load list')
         this.getData()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            // console.log(result)
            })
            .catch(error => {
               this.write(`------ ${error?.message ?? JSON.stringify(error)}`)
            // console.log(error)
            })
      },
      onLoadListError() {
         this.setReset()
         this.write('Start : Load list error only')
         this.getDataError()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            // console.log(result)
            })
            .catch(error => {
               this.write(`------ ${error?.message ?? JSON.stringify(error)}`)
            // console.log(error)
            })
      },
      onLogin() {
         this.write('Login')
         this.loading = true
         this.loginOss().then(
            res => {
               this.write(`------ ${res.message}`)
               this.$toast.success(res.message)
               this.loading = false
            },
            () => {
               this.write('------ Gagal Login')
               this.loading = false
            },
         )
      },
      write(text) {
         if (this.term) {
            this.term.write(`${text}\n\r`)
         }
      },
      handleResize() {
         if (this.fitAddon) {
            this.fitAddon.fit()
         }
      },
   },
}
</script>

F<template>
   <b-row>
      <b-col cols="12" xl="4" lg="4" md="4">
         <b-card title="Jumlah">
            <b-row>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center mr-2">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="DollarSignIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCountDetail }}
                        </h5>
                        <small>Total NIB (yang berhasil ditarik)</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="TrendingUpIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCount }}
                        </h5>
                        <small>Total NIB (Source)</small>
                     </div>
                  </div>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Status">
            <b-row>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center mr-2">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="DollarSignIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCurrent }}
                        </h5>
                        <small>Current / Posisi</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-success" rounded>
                        <feather-icon icon="TrendingUpIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ mySuccess }}
                        </h5>
                        <small>Sukses</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-danger" rounded>
                        <feather-icon icon="TrendingUpIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myFailed }}
                        </h5>
                        <small>Error</small>
                     </div>
                  </div>
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-form-input v-model="current" :disabled="myState" type="number" placeholder="Enter Posisi" />
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="myState" variant="secondary" block @click="onStart">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Start
                  </b-button>
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="!myState" variant="danger" block @click="onStop">
                     Stop
                  </b-button>
               </b-col>
               <b-col md="6" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadList()">
                     Load All
                  </b-button>
               </b-col>
               <b-col md="6" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadListError()">
                     Load Error Only
                  </b-button>
               </b-col>
               <b-col md="12" class="mb-1">
                  <hr>
                  <b-button :disabled="isLoading" variant="secondary" block @click="onLogin">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Login
                  </b-button>
               </b-col>
            </b-row>
         </b-card>
      </b-col>
      <b-col cols="12" md="8" xl="8" lg="8">
         <b-card title="Action">
            <b-row>
               <b-col md="12">
                  <div>
                     <!-- <label>Progress label with precision</label> -->
                     <b-progress
                        :value="myCurrent"
                        :max="myCount"
                        precision="2"
                        show-progress
                        variant="primary"
                        class="progress-bar-warning"
                     />
                  </div>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Logs">
            <b-row>
               <b-col md="12">
                  <div>
                     <!-- <label>Progress label with precision</label> -->
                     <div id="terminal-container" ref="terminalContainer" />
                  </div>
               </b-col>
            </b-row>
         </b-card>
      </b-col>

   </b-row>
</template>

<style scoped>
#terminal-container {
  /* Berikan dimensi yang jelas pada kontainer */
  width: 100%;
  height: 400px;
  border: 1px solid #555;
  padding: 5px;
}
</style>
